import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Button, Select, List, Icon } from 'antd'

import EditRightParam from './EditRightParam'
import { popupStore } from 'store'

@inject((store: any) => {
    const {
        popupStore,
        parametersStore,
        rightParamSetStore,
        paramGroupsStore,
        rightsParametersStore,
        rightsStore
    } = store
    return { popupStore, parametersStore, rightParamSetStore, paramGroupsStore, rightsParametersStore, rightsStore }
})
@observer
export default class RightParametersPopup extends Component<any, any> {
    state: any = {
        errors: {},
        notice: false
    }
    toggleNotice = () => {
        this.setState(prevState => ({ notice: !prevState.notice }))
    }
    handleDeleteAllParams = async () => {
        const { rightsParametersStore } = this.props
        const { id: right_id, policy_id } = popupStore.info
        try {
            await rightsParametersStore.deleteRightParameters({ right_id, policy_id })
            await this.udpateRightParameters()
            this.toggleNotice()
        } catch (e) {
            console.log(e)
        }
    }
    udpateRightParameters = async () => {
        const { rightsStore, parametersStore } = this.props
        const { right_param_set_id, policy_id, id: right_id } = this.props.popupStore.info
        try {
            await rightsStore.getRightsList({ right_param_set_id, policy_id })
            await rightsStore.applyFilters()
            await parametersStore.getParametersList({ policy_id, right_param_set_id, right_id })
        } catch (e) {
            console.log(e)
        }
    }
    closePopup = () => {
        this.setState({ notice: false })
        this.props.parametersStore.resetParameters()
        this.props.popupStore.togglePopup(false)
    }
    render() {
        const { popupStore, parametersStore, paramGroupsStore } = this.props
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <Button onClick={this.closePopup}>סגור</Button>
            </div>
        )
        const relevant = this.props.popupStore.info.__meta__
            ? this.props.popupStore.info.__meta__.right_parameters_count
            : false
        const headerMessage = (
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <div>
                    הגדרות פרמטרים בזכות {popupStore.info.name} (מזהה: {popupStore.info.id})
                </div>
                <div>
                    {!this.state.notice && !!relevant && (
                        <Button style={{ marginLeft: '0' }} onClick={() => this.toggleNotice()}>
                            <Icon type="stop" />
                            הפוך כיסוי ללא רלוונטי
                        </Button>
                    )}
                </div>
            </div>
        )
        return (
            <Modal
                title={headerMessage}
                visible={popupStore.popupType === 'rightParameters'}
                cancelText="ביטול"
                width={850}
                bodyStyle={{ padding: '0.5rem 1.5rem 3rem 1.5rem' }}
                onCancel={this.closePopup}
                footer={footerButtons}
            >
                {this.state.notice && (
                    <div style={{ backgroundColor: '#822525', padding: '1rem', color: 'white', margin: '0.5rem 0' }}>
                        <strong style={{ fontSize: '1.1rem', marginLeft: '0.5rem' }}>אזהרה!</strong>
                        <span>
                            משמעות הפעולה היא שכל הגדרות הפרמטרים אל מול כיסוי זה ופוליסה זו יהפכו ללא רלוונטיים
                        </span>
                        <div style={{ fontWeight: 'bold' }}>
                            <a onClick={() => this.handleDeleteAllParams()} style={{ textDecoration: 'underline' }}>
                                הפוך כיסוי ללא רלוונטי
                            </a>
                            |
                            <a onClick={() => this.toggleNotice()} style={{ textDecoration: 'underline' }}>
                                בטל פעולה
                            </a>
                        </div>
                    </div>
                )}
                <div style={{ display: 'flex', width: '100%' }}>
                    <div style={{ width: '33.3%', paddingLeft: '0.2rem' }}>
                        <Input.Search
                            value={parametersStore.filters['name']}
                            onChange={e => parametersStore.addFilter('name', e.target.value)}
                            placeholder="חיפוש על פי שם"
                        />
                    </div>
                    <div style={{ width: '33.3%', padding: '0 0.2rem' }}>
                        <Select
                            style={{ width: '100%' }}
                            placeholder="סנן על פי רלוונטיות"
                            value={parametersStore.filters['relevant']}
                            onChange={e => parametersStore.addFilter('relevant', e)}
                        >
                            <Select.Option value={null}>הצג הכל</Select.Option>
                            <Select.Option value="NOTRELEVANT">לא רלוונטיים</Select.Option>
                            <Select.Option value="RELEVANT">רלוונטיים</Select.Option>
                        </Select>
                    </div>
                    <div style={{ width: '33.3%', paddingRight: '0.2rem' }}>
                        <Select
                            style={{ width: '100%' }}
                            placeholder="סנן על פי קבוצה"
                            value={parametersStore.filters['param_group_id']}
                            onChange={e => parametersStore.addFilter('param_group_id', e)}
                        >
                            <Select.Option value={null} key="all">
                                כל הקבוצות
                            </Select.Option>
                            {paramGroupsStore.list.map((paramGroup, index) => (
                                <Select.Option value={paramGroup.id} key={index}>
                                    {paramGroup.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                </div>
                <div>
                    <label>
                        <strong>
                            מציג {parametersStore.filteredList.length}
                            <label></label> פרמטרים
                        </strong>
                    </label>
                </div>
                <List
                    dataSource={parametersStore.filteredList}
                    pagination={{
                        pageSize: 8,
                        total: parametersStore.filteredList.length
                    }}
                    renderItem={item => (
                        <List.Item style={{ padding: '0' }}>
                            <EditRightParam {...item} />
                        </List.Item>
                    )}
                />
            </Modal>
        )
    }
}
